const React = require('react')
const { Modal, ModalHeader, ModalBody, UncontrolledTooltip } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { QRCodeSVG } = require('qrcode.react')

require('@styles/components/qrCodeButton.css')

const QRCodeButton = props => {
    const { id, url, text } = props
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    const { network } = useNetworkConfig()

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
    }

    return (
        <>
            <div
                id={id}
                onClick={toggleModal}
                className={`${network.name}-icon-wrapper`}
                style={{
                    marginLeft: '4px',
                    cursor: 'pointer',
                    display: 'inline-block'
                }}
            >
                <i className='fa fa-qrcode' />
            </div>
            <UncontrolledTooltip placement='top' target={`${id}`}>
                <span id={`tooltip-${url}`} style={{ color: 'var(--white-color)' }}>
                    Click to view QR code
                </span>
            </UncontrolledTooltip>

            <Modal isOpen={isModalOpen} toggle={toggleModal} className='qr-modal'>
                <ModalHeader toggle={toggleModal}>Address QR Code</ModalHeader>
                <ModalBody className='text-center'>
                    <QRCodeSVG
                        value={url}
                        size={200}
                        level='H'
                        title={url}
                        fgColor={'var(--white-color)'}
                        bgColor={'var(--black-background)'}
                    />
                    <div className='qr-code-text'>{text}</div>
                </ModalBody>
            </Modal>
        </>
    )
}

module.exports = { QRCodeButton }
